/* eslint-disable */
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import Cookies from 'js-cookie';
import scLogo from '../assets/Logo.png';
// import googleLogo from '../assets/google.png';
import '../styles/GoogleCallback.css';

function GoogleSignupCallback() {
  const googleLogo = 'https://www.google.com/images/branding/googlelogo/1x/googlelogo_color_272x92dp.png';
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleGoogleCallback = async () => {
      try {
        const { search } = window.location;
        const params = new URLSearchParams(search);
        const code = params.get('code');

        if (!code) {
          setError('Authorization code not found');
          setLoading(false);
          return;
        }

        const response = await api.googleSignupCallback(code);
        if (response?.user_id) {
          localStorage.setItem('user_id', response.user_id);
          Cookies.set('sc_Token', response?.access_token);
          navigate('/user-details');
        } else if (response?.manual === true) {
          try {
            const data = JSON.parse(response.message);
            if (data.is_error || data?.is_error === 'true') {
              setError(data.error || data.message || 'An error occurred during signup');
              setLoading(false);
              setTimeout(() => {
                navigate('/signup');
              }, 2000);
            }
          } catch (err) {
            console.error('Error parsing manage data:', err);
            setError('An error occurred while processing your request');
            setLoading(false);
          }
        } else {
          setError('Failed to authenticate with Google. Please try again.');
          navigate('/');
        }
        setLoading(false);
      } catch (error) {
        setError('Failed to authenticate with Google. Please try again.');
        setLoading(false);
      }
    };

    handleGoogleCallback();
  }, [navigate]);

  return (
    <div className="google-callback-container">
      <div className="google-callback-box">
        <div className="logos">
          <img src={scLogo} alt="SalesCaptain Logo" className="sc-logo" />
          <div className="connecting-line"></div>
          <img src={googleLogo} alt="Google Logo" className="google-logo" />
        </div>
        
        {loading ? (
          <div className="loading-container">
            <div className="spinner"></div>
            <p>Connecting your Google account...</p>
          </div>
        ) : error ? (
          <div className="error-container">
            <p className="error-message">{error}</p>
            <button 
              className="retry-button"
              onClick={() => navigate('/signup')}
            >
              Back to Sign Up
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default GoogleSignupCallback; 